module.exports = __webpack_public_path__ + "img/app-mockup.9773626d.png";